import React, { useState } from "react";
import { motion } from "framer-motion";
import Navbar from "../../components/layout/Navbar";

const imageVariants = {
  open: {
    opacity: 0.6,
    x: "-100%",
    transition: {
      duration: 1,
      type: "spring",
    },
  },
  hidden: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      type: "spring",
    },
  },
};

const ProductDemo = () => {
  // Hooks
  const [currentProductDemoItem, setCurrentProductDemoItem] = useState(0);
  const [isButtonsClicked, setIsButtonsClicked] = useState(false);

  // Next Product Demo Item
  const handleNextProductDemoItem = () => {
    if (currentProductDemoItem < productDemoData.length - 1) {
      setIsButtonsClicked(true);

      setTimeout(() => {
        setCurrentProductDemoItem(
          (currentProductDemoItem) => currentProductDemoItem + 1
        );
        setIsButtonsClicked(false);
      }, 500);
    }
  };

  // Prev Product Demo Item
  const handlePrevProductDemoItem = () => {
    if (currentProductDemoItem > 0) {
      setIsButtonsClicked(true);

      setTimeout(() => {
        setCurrentProductDemoItem(
          (currentProductDemoItem) => currentProductDemoItem - 1
        );
        setIsButtonsClicked(false);
      }, 500);
    }
  };

  return (
    <>
      <Navbar />
      <div className="productdemo">
        <div className="productdemo__container">
          <div className="productdemo__container__header">
            <div className="productdemo__container__header__content">
              <h4 className="productdemo__container__header__content__subheading heading-secondary--sub">
                KNOW THE PRODUCT
              </h4>
              <h1 className="productdemo__container__header__content__heading heading-primary--main">
                Look At How We're Transforming Fitness
              </h1>
            </div>
          </div>

          <div className="productdemo__container__content">
            <motion.div
              className="productdemo__container__content__image"
              animate={isButtonsClicked ? "open" : "hidden"}
              variants={imageVariants}
            >
              <img
                src={productDemoData[currentProductDemoItem].image}
                alt="product images"
                className="productdemo__container__content__image__container"
              />
            </motion.div>
            <div className="productdemo__container__content__actions">
              <h1 className="productdemo__container__content__actions__heading heading-secondary--main">
                {productDemoData[currentProductDemoItem].heading}
              </h1>
              <p className="productdemo__container__content__actions__text heading-secondary--sub">
                {productDemoData[currentProductDemoItem].text}
              </p>
              <div className="productdemo__container__content__actions__buttons">
                {currentProductDemoItem !== productDemoData.length - 1 ? (
                  <motion.button
                    className="btn btn-sm productdemo__container__content__actions__buttons__next"
                    onClick={handleNextProductDemoItem}
                  >
                    Next
                  </motion.button>
                ) : (
                  ""
                )}
                {currentProductDemoItem > 0 ? (
                  <button
                    className="btn btn-sm productdemo__container__content__actions__buttons__prev"
                    onClick={handlePrevProductDemoItem}
                  >
                    Prev
                  </button>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>

          <section className="productdemo__container__footer">
            <div className="productdemo__container__footer__content">
              <h4 className="productdemo__container__footer__content__subheading heading-secondary--sub">
                PAY LESS, DO MORE
              </h4>
              <h1 className="productdemo__container__footer__content__heading heading-secondary--main">
                Ready to subscribe
              </h1>
              <div className="productdemo__container__footer__content__buttons">
                <button className="btn btn-md productdemo__container__footer__content__buttons__subscribe">
                  Subscribe Now
                </button>
                <button className="btn btn-md productdemo__container__footer__content__buttons__connectsales">
                  Connect me with sales
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ProductDemo;

const productDemoData = [
  {
    heading: "Your dashboard with minimal interfaces",
    text:
      "The screen that connects you with your needs, from single screen that connect you to all of them.",
    image: "assets/images/product/admin-dashboard.png",
  },
  {
    heading: "View all members in your gym",
    text: "Track how many members have joined your gym.",
    image: "assets/images/product/admin-all-members.png",
  },
  {
    heading: "View a member",
    text: "Get payments and check-ins for a member in one click",
    image: "assets/images/product/admin-view-user-profile.png",
  },

  {
    heading: "Accept payment from your members",
    text:
      "Initiate payment in one click, no need to write on a register anymore.",
    image: "assets/images/product/admin-accept-payment.png",
  },
  {
    heading: "Just one tap, You're in!",
    text:
      "Check-in your members in one click. They'll use this feature with their account.",
    image: "assets/images/product/user-dashboard.png",
  },
  {
    heading: "They know when to pay.",
    text: "Your members can track down their previous and upcoming payments.",
    image: "assets/images/product/user-payment-dashboard.png",
  },
];
